import Fetch from '../../../mixins/Fetch'
import store from '../../../store/index'

// Carrega a lista de solicitações
const loadSolicitacoes = async ({ commit }, obj) => {
  const request = await Fetch.get(`solicitation/get/${obj.status}/${obj.currentPage}`)

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const solicitacoes = []

  result.items.forEach(data => {
    const makeIconStatus = (temp) => ({
      Editado: { name: 'square-fill', color: 'warning' },
      Iniciado: { name: 'square-fill', color: 'primary' },
      Aprovado: { name: 'square-fill', color: 'success' },
      Represado: { name: 'square-fill', color: 'danger' },
      Informação: { name: 'square-fill', color: 'secondary' },
      Backoffice: { name: 'square-fill', color: 'dark' }
    })[temp]

    const status = makeIconStatus(data.status)

    solicitacoes.push({
      id: data.id,
      idUnidade: data.idUnidade,
      data: data.data,
      nomeEmpreendimento: data.nomeEmpresa,
      tipoEmpreendimento: data.tipoEmpreendimento,
      codigoEmpreendimento: data.codigoEmpresa,
      sobrenome: data.sobrenome,
      cnpj: data.cnpj,
      telComercial: data.telefoneComercial,
      cep: data.cep,
      cidadeRegiao: data.cidade,
      rua: data.rua,
      rua2: data.rua2,
      complemento: data.complemento ? data.complemento : null,
      numero: data.numero,
      bairro: data.bairro,
      emailComercial: data.emailComercial,
      nomeComercial: data.nomeComercial,
      nomeEmpresa: data.nomeEmpresa,
      protocolo: data.protocolo,
      modalidadeEntrega: data.modalidadeEntrega,
      nomeServico: data.nomeServico,
      status,
      iniciado: data.iniciado,
      nomeSol: data.nomeSolicitante,
      cpfSol: data.cpfSolicitante,
      emailSol: data.emailSolicitante,
      telSol: data.telefoneSolicitante,
      tipoServico: data.tipoServico,
      unitHabitacional: data.unitHabitacional,
      prevConclusao: data.prevConclusao,
      prevLancamento: data.prevLancamento,
      areaTerreno: data.areaTerreno,
      rgipde: data.rgipde,
      formaPagamento: data.formaPagamento
    })
  })

  commit('SETSTATUSFILTER', obj.status)
  commit('SETSOLICITACOES', solicitacoes)
  // commit('SETCOUNTSOLICITATION', request.total)
  commit('SETPAGINATION', {
    pageCount: result.pageCount,
    totalItemCount: result.totalItemCount,
    pageNumber: obj.currentPage,
    pageSize: result.pageSize
  })
}

// Atualiza a cidade/região do empreendimento
const updateCity = async ({ commit }, params) => {
  // ID da solicitação e o id da nova cidade/região para o empreendimento
  const result = Fetch.get(`ownership/up/${params.campos[0].idSolic}/${params.campos[0].idNewCity}`)
    .then(response => {
      if (response.status !== 200) {
        throw Error(response.statusText)
      }

      return response.data
    })
    .catch((err) => { return err })

  return result
}

// Atualiza o tipo de serviço da solicitação
const updateTypeService = async ({ commit }, params) => {
  // ID da solicitação e o id do novo tipo de serviço que a solicitação terá
  const result = Fetch.get(`solicitation/up/${params.campos[0].idSolic}/${params.campos[0].idNewSolic}`)
    .then(response => {
      if (response.status !== 200) {
        throw Error(response.statusText)
      }

      return response.data
    })
    .catch((err) => { return err })

  return result
}

// Atualiza o estado da solicitação
const changeStatus = async ({ commit, getters }, objProtocolo) => {
  const solicitacoesFilter = getters.getSolicitacoes.filter(r => { return r.protocolo !== objProtocolo })
  commit('SETSOLICITACOES', solicitacoesFilter)
}

const loadFiles = async ({ commit }, protocolo) => {
  const request = Fetch.get('archive/getbyprotocol', protocolo)

  if (request.status === 'error') throw new Error(request.message)

  const files = []
  request.then(resp => resp.map(e => files.push(e)))

  commit('SETFILES', files)
}

const downloadFile = async ({ commit }, id) => {
  const request = Fetch.get('archive/getbyid', id, 'blob')

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const downloadPathZip = async ({ commit }, protocolo) => {
  const request = Fetch.get('archive/downloadzipfile', protocolo, 'blob')

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const loadHistorics = async ({ commit }, params) => {
  const request = Fetch.get('historic/getbyprotocol', params)

  if (request.status === 'error') throw new Error(request.message)

  const response = request
  const list = []
  response.then(r => r.map(l => list.push(l)))

  commit('SETHISTORICS', list)
}

const loadReasons = async ({ commit }, tipo) => {
  const request = await Fetch.get('reason/get', tipo)

  if (request.status === 'error') throw new Error(request.message)

  const response = request
  const list = []

  response.map(re => list.push({ value: re.id, text: re.descricao }))

  commit('SETREASONS', list)
}

const postHistoric = async ({ commit }, params) => {
  const request = await Fetch.post('historic/add', params)

  if (request.status === 'error') throw new Error(request.message)

  return request
}

const loadOwnerShips = async ({ commit }) => {
  const request = await Fetch.get('ownership/getownerships')

  if (request.status === 'error') throw new Error(request.message)

  const response = request

  commit('SETEMPREENDIMENTOS', response)
}

const loadOwnerShipsUser = async ({ commit }) => {
  const request = await Fetch.get('ownership/get')

  if (request.status === 'error') throw new Error(request.message)

  const response = request

  commit('SETEMPREENDIMENTOSUSER', response)
}

const loadServices = async ({ commit }) => {
  const profile = localStorage.getItem('idPerfil')
  const request = await Fetch.get(`service/get/${profile}`)

  if (request.status === 'error') throw new Error(request.message)

  const response = request

  commit('SETSERVICES', response)
}

const filteredSolicitationTyped = async ({ commit }, obj) => {
  const url = store.getters['Global/getApiBaseUrl']
  const request = await fetch(`${url}solicitation/getFilteredSolicitationTyped`, {
    method: 'POST',
    headers: {
      Authorization: `bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(obj)
  }).then(a => a.json())

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const solicitacoes = []

  const makeIconStatus = (temp) => ({
    Editado: { name: 'square-fill', color: 'warning' },
    Iniciado: { name: 'square-fill', color: 'primary' },
    Aprovado: { name: 'square-fill', color: 'success' },
    Represado: { name: 'square-fill', color: 'danger' },
    Informação: { name: 'square-fill', color: 'secondary' },
    Backoffice: { name: 'square-fill', color: 'dark' }
  })[temp]

  result.result.forEach(data => {
    const status = makeIconStatus(data.status)

    solicitacoes.push({
      id: data.id,
      idUnidade: data.idUnidade,
      data: data.data,
      nomeEmpreendimento: data.nomeEmpresa,
      tipoEmpreendimento: data.tipoEmpreendimento,
      codigoEmpreendimento: data.codigoEmpresa,
      sobrenome: data.sobrenome,
      cnpj: data.cnpj,
      telComercial: data.telefoneComercial,
      cep: data.cep,
      cidadeRegiao: data.cidade,
      rua: data.rua,
      rua2: data.rua2,
      complemento: data.complemento ? null : data.complemento,
      numero: data.numero,
      bairro: data.bairro,
      emailComercial: data.emailComercial,
      nomeComercial: data.nomeComercial,
      nomeEmpresa: data.nomeEmpresa,
      protocolo: data.protocolo,
      modalidadeEntrega: data.modalidadeEntrega,
      nomeServico: data.nomeServico,
      status,
      iniciado: data.iniciado,
      nomeSol: data.nomeSolicitante,
      cpfSol: data.cpfSolicitante,
      emailSol: data.emailSolicitante,
      telSol: data.telefoneSolicitante,
      tipoServico: data.tipoServico,
      unitHabitacional: data.unitHabitacional,
      prevConclusao: data.prevConclusao,
      prevLancamento: data.prevLancamento,
      areaTerreno: data.areaTerreno,
      rgipde: data.rgipde,
      formaPagamento: data.formaPagamento
    })
  })

  commit('SETSTATUSFILTER', obj.status)
  commit('SETSOLICITACOES', solicitacoes)
  // commit('SETCOUNTSOLICITATION', request.total)
  commit('SETPAGINATION', {
    pageCount: result.pageCount,
    totalItemCount: result.totalItemCount,
    pageNumber: result.currentPage + 1,
    pageSize: result.pageSize
  })
}

const filteredSolicitation = async ({ commit }, obj) => {
  const url = store.getters['Global/getApiBaseUrl']
  const request = await fetch(`${url}solicitation/getFilteredSolicitation`, {
    method: 'POST',
    headers: {
      Authorization: `bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(obj)
  }).then(a => a.json())

  if (request.status === 'error') throw new Error(request.message)

  const result = request
  const solicitacoes = []

  const makeIconStatus = (temp) => ({
    Editado: { name: 'square-fill', color: 'warning' },
    Iniciado: { name: 'square-fill', color: 'primary' },
    Aprovado: { name: 'square-fill', color: 'success' },
    Represado: { name: 'square-fill', color: 'danger' },
    Informação: { name: 'square-fill', color: 'secondary' },
    Backoffice: { name: 'square-fill', color: 'dark' }
  })[temp]

  result.items.forEach(data => {
    const status = makeIconStatus(data.status)

    solicitacoes.push({
      id: data.id,
      idUnidade: data.idUnidade,
      data: data.data,
      nomeEmpreendimento: data.nomeEmpresa,
      tipoEmpreendimento: data.tipoEmpreendimento,
      codigoEmpreendimento: data.codigoEmpresa,
      sobrenome: data.sobrenome,
      cnpj: data.cnpj,
      telComercial: data.telefoneComercial,
      cep: data.cep,
      cidadeRegiao: data.cidade,
      rua: data.rua,
      rua2: data.rua2,
      complemento: data.complemento ? null : data.complemento,
      numero: data.numero,
      bairro: data.bairro,
      emailComercial: data.emailComercial,
      nomeComercial: data.nomeComercial,
      nomeEmpresa: data.nomeEmpresa,
      protocolo: data.protocolo,
      modalidadeEntrega: data.modalidadeEntrega,
      nomeServico: data.nomeServico,
      status,
      iniciado: data.iniciado,
      nomeSol: data.nomeSolicitante,
      cpfSol: data.cpfSolicitante,
      emailSol: data.emailSolicitante,
      telSol: data.telefoneSolicitante,
      tipoServico: data.tipoServico,
      unitHabitacional: data.unitHabitacional,
      prevConclusao: data.prevConclusao,
      prevLancamento: data.prevLancamento,
      areaTerreno: data.areaTerreno,
      rgipde: data.rgipde,
      formaPagamento: data.formaPagamento
    })
  })

  commit('SETSTATUSFILTER', obj.status)
  commit('SETSOLICITACOES', solicitacoes)
  // commit('SETCOUNTSOLICITATION', request.total)
  commit('SETPAGINATION', {
    pageCount: result.pageCount,
    totalItemCount: result.totalItemCount,
    pageNumber: result.pageNumber,
    pageSize: result.pageSize
  })
}

const updateStatus = ({ commit }, status) => {
  commit('SETSTATUS', status)
}

const changeClicked = ({ commit }, obj) => {
  commit('SETCLICKED', obj)
}

const loadDeadline = async ({ commit }, obj) => {
  const request = await Fetch.get(`deadline/get/${obj.protocol}/${obj.status}`)

  if (request.status === 'error') throw new Error(request.message)

  commit('SETSHOWDEADLINE', true)

  return request
}

const toggleShowDeadline = async ({ commit }) => {
  commit('SETSHOWDEADLINE', false)
}

const updateNumeroIdDiretriz = async ({ commit }, params) => {
  const obj = new FormData()
  obj.append('protocolo', params.protocolo)
  obj.append('numero', params.numero)
  obj.append('idUsuario', localStorage.getItem('id'))

  const request = await Fetch.post('solicitation/changeNumeroIdDiretriz', obj)

  return request
}

const loadNumeroIdDiretriz = async ({ commit }, protocolo) => {
  const request = await Fetch.get('solicitation/getNumeroIdDiretriz', protocolo)

  if (request?.status === 'error') throw Error(request.message)

  commit('SETNUMEROIDDIRETRIZ', request)
}

const loadAddressHistoric = async ({ commit }, obj) => {
  const request = await Fetch.post('solicitation/getAddressHistoricByProtocol', obj)

  if (request.status === 'error') throw new Error(request.message)

  commit('SETADDRESSHISTORIC', request)

  return request
}

const addAttachmentFromEdition = async ({ commit }, data) => {
  const errors = []
  const formData = data.formData

  for (const el of data.files) {
    const infoFile = new FormData()

    await [...formData].forEach((el) => {
      infoFile.append(el[0], el[1])
    })

    infoFile.append('anexo', el)

    const request = await Fetch.post(
      'archive/addattachmentfromedit',
      infoFile
    )

    if (request.status === 'error') errors.push(request.message)
  }

  return { error: errors }
}

const fillFilesHasChanges = ({ commit }, info) => {
  commit('SETFILESHASCHANGES', info)
}

const loadAltCancelAprovegrant = async ({ commit }) => {
  const request = await Fetch.get('user/hasAltCancelAproveGrant')

  if (request.status === 'error') throw new Error(request.message)

  commit('SETALTCANCELAPROVEGRANT', request)
}

const loadPendingAltCancelList = async ({ commit }, page) => {
  commit('SETISPENDINGREQUESTALTCANC', true)
  const request = await Fetch.get(`historic/getPendingAltCancelHistorics/${page}`)
  commit('SETISPENDINGREQUESTALTCANC', false)

  if (request.status === 'error') throw new Error(request.message)

  commit('SETPENDINGALTCANCELLIST', request.list)

  commit('SETALTCANCPAGINATION', {
    pageCount: request.pageCount,
    totalItemCount: request.totalItemCount,
    pageNumber: request.pageNumber,
    pageSize: request.pageSize
  })
}

const loadPendingAltCancCommentDetails = async ({ commit }, idAltCanc) => {
  const request = await Fetch.get(`historic/getAltCancCommentDetails/${idAltCanc}`)

  if (request.status === 'error') throw new Error(request.message)

  commit('SETPENDINGALTCANCCOMMENTDETAILS', request)
}

const aproveAltCancComment = async ({ commit }, info) => {
  const request = await Fetch.post('historic/aproveAltCancComment', info)

  if (request.status === 'error') throw new Error(request.message)

  return request
}

export default {
  loadFiles,
  updateCity,
  loadReasons,
  loadServices,
  updateStatus,
  changeStatus,
  downloadFile,
  postHistoric,
  loadHistorics,
  loadOwnerShips,
  downloadPathZip,
  loadSolicitacoes,
  updateTypeService,
  loadOwnerShipsUser,
  filteredSolicitationTyped,
  changeClicked,
  loadDeadline,
  toggleShowDeadline,
  updateNumeroIdDiretriz,
  loadNumeroIdDiretriz,
  loadAddressHistoric,
  addAttachmentFromEdition,
  fillFilesHasChanges,
  loadAltCancelAprovegrant,
  loadPendingAltCancelList,
  loadPendingAltCancCommentDetails,
  aproveAltCancComment,
  filteredSolicitation
}
